import { createBrowserRouter } from "react-router-dom";

import Portfolio from "../pages/Portfolio";
import NotFound from "../pages/NotFound";
import Maintenance from "../pages/Maintenance";
import Login from "../pages/Login";
import Admin from "../pages/Admin";
import DataUpload from "../pages/DataUpload";
import { ForgotPassword } from "../pages/ForgotPassword";
import Settings from "../pages/Settings";

import RootLayout from "../RootLayout";
import PrivateRoutes from "./PrivateRoutes";
import { UpdatePasswordModal } from "../components/UpdatePassword";
import CaseDetails from "../components/CaseDetails";
import { BulkMessage } from "../pages/BulkMessage";
import Campaign from "../pages/Campaign";
import Analytics from "../pages/Analytics";
import PredictiveDailer from "../pages/Autodialer";
import BulkEmail from "../pages/BulkEmail";
import CallLogs from "../pages/CallLogs/CallLogs";
import { Dialler } from "../pages/Dialler/Dialler";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [{ index: true, element: <Login /> }],
  },
  {
    path: "/forgot-password",
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [{ index: true, element: <ForgotPassword /> }],
  },
  {
    path: "/maintenance",
    element: <Maintenance />,
  },
  {
    element: <PrivateRoutes />,
    children: [
      {
        path: "/",
        element: <Portfolio />,
      },
      {
        path: "/portfolio/:id",
        element: <CaseDetails />,
      },
      {
        path: "/user-management",
        element: <Admin />,
      },
      {
        path: "/data-upload",
        element: <DataUpload />,
      },
      {
        path: "/update-password",
        element: <UpdatePasswordModal />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
      {
        path: "/bulkmessage",
        element: <BulkMessage />,
      },
      {
        path: "/campaign",
        element: <Campaign />,
      },
      {
        path: "/lender-analysis/:lenderId",
        element: <Analytics/>,
      },
       {
        path: "/predictive-dialer",
        element: <PredictiveDailer/>,
      },
       {
        path: "/bulkemail",
        element: <BulkEmail/>,
      },
        {
        path: "/call-logs",
        element: <CallLogs/>,
      },
       {
        path: "/dialler",
        element: <Dialler/>,
      },
    ],
  },
]);

export default router;
